import { StubModule } from "../../../shared/components/StubModule";
import { useConnectAction } from "../../../services/auth/useConnectAction";
import { EngageWorkflowPanel } from "./EngageWorkflowPanel";

interface EngageModuleProps {
  readonly onBack?: () => void;
  readonly userEmail?: string;
  readonly onOpenSettings?: () => void;
}

export function EngageModule({
  onBack,
  userEmail,
  onOpenSettings,
}: Readonly<EngageModuleProps> = {}) {
  const connectAction = useConnectAction("engage", "Connect Engage");
  // `connectAction.connected` is driven by adapter.onTokenChange, so it
  // flips to true once the silent re-auth kicked off in useConnectAction
  // completes after a page refresh.
  const connected = connectAction?.connected ?? false;

  if (connected) {
    return <EngageWorkflowPanel onBack={onBack} userEmail={userEmail} />;
  }

  return (
    <StubModule
      title="Engage Workflow"
      subtitle="Submit emails and documents as workflow jobs"
      noticeTitle="Connect Engage to continue"
      noticeMessage="Engage uses AWS Cognito + Azure SAML federation."
      features={[
        "Multi-tenant site selection (per-user permissions)",
        "Job type loading per site",
        "Requestor lookup by email",
        "Internal job creation with attachment management",
        "EML export and email-to-job conversion",
        "Email category tagging on submission",
      ]}
      onBack={onBack}
      connectAction={connectAction}
      onOpenSettings={onOpenSettings}
    />
  );
}
